/**
 * ヘッダー固有の値。対応する Component 層のトークンは front-lib にあるが、Component 層は
 * 配布されていない（DD 0002 の D1、Deferred）ので変数として参照できず、ここに持つ。
 */
const globalAreaV2Sizes = {
  /** `component.header.height` に対応。下端の区切り線を含む（border-box）。 */
  rowHeight: '56px',
  /** `component.gradientBar.height` に対応。 */
  gradientBarHeight: '6px',
  /** `component.header.logoHeight` に対応。 */
  logoHeight: '32px',
} as const;

/**
 * ヘッダー下端のブランドグラデーション。上の 3 件と違い front-lib のどの層にも値が無い
 * （`component.gradientBar` は `height` のみ、中間の停止色は Primitive の ramp にも無い）。
 */
const brandGradient = 'linear-gradient(90deg, #002169 0%, #005B8C 40%, #00B4A0 70%, #00FDA0 100%)' as const;

export { brandGradient, globalAreaV2Sizes };
